import * as React from 'react';
import { Button, Stack, TextField, useMediaQuery, Box, FormControl, useTheme, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../../components/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { getDealers } from '../../../redux/slice/dealer.slice';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import DownloadIcon from '@mui/icons-material/Download';
import { createAccount, getAccount, getAllMarketingData, updateAccount } from '../../../redux/slice/account.slice';
import { Image_URL } from '../../../utils/baseURL';

export default function Addaccount() {
    const imgUrl = Image_URL;
    const location = useLocation();
    const { mid, Dealerid } = location.state || {};
    const marketdealer = useSelector(state => state.account.market)?.find(market => market._id === mid)
    const isMobile = useMediaQuery('(max-width:500px)');

    const paymentDetailIds = marketdealer?.dealerData?.[0]?.PaymentDetails?.map(detail => detail?._id);
    const dispatch = useDispatch();
    const [id, setid] = React.useState(null)

    React.useEffect(() => {
        if (id) {
            setValues(account);
        }
    }, [id, dispatch]);


    const validationSchemas =
        Yup.object({});

    const initialValues = {
        AccountDetails: [{
            AccountDate: '',
            AccountAmount: '',
            AccountRemarks: '',
            dealerEntoeryId: paymentDetailIds ? paymentDetailIds[0] : null,
        }]
    };

    const isNonMobile = useMediaQuery("(min-width:600px)");
    const theme = useTheme();

    const { handleBlur, handleChange, values, touched, errors, resetForm, setFieldValue, setValues, validateForm } = useFormik({
        initialValues,
        validationSchema: validationSchemas,
    });

    const handleSubmit = () => {
        const submissionValues = {
            ...values,
            matketId: mid,
            Dealer: Dealerid,
            AccountDetails: values.AccountDetails.map((detail, index) => {
                return {
                    ...detail,
                    dealerEnteryId: marketdealer?.dealerData?.[0]?.PaymentDetails[index]?._id || null,
                };
            }),
            AmountMarket: marketdealer.TotalAmount,
            TotalAccountAmount: values.AccountDetails.reduce((acc, curr) => acc + Number(curr.AccountAmount || 0), 0),
            pendingAmount: marketdealer.TotalAmount - values.AccountDetails.reduce((acc, curr) => acc + Number(curr.AccountAmount || 0), 0),
        };

        const isValid = submissionValues.AccountDetails.every((detail, index) => {
            const maxAmount = matchedDealerssss[index]?.PaymentAmount || 0;
            if (Number(detail.AccountAmount) < maxAmount) {
                alert(`Account Amount cannot be less than the maximum allowed amount of ${maxAmount}`);
                return false;
            }
            return true;
        });

        if (isValid) {
            if (id) {
                dispatch(updateAccount({ id, submissionValues }));
            } else {
                dispatch(createAccount({ submissionValues }));
            }
            resetForm();
            navigate('/admin/customer-payment');
        }
    };

    const [openView, setOpenView] = React.useState(false);
    const [viewImage, setViewImage] = React.useState(null);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const downloadRef = React.useRef(null);

    const handleView = (imageUrl) => {
        setViewImage(imageUrl);
        setOpenView(true);
    };

    const handleCloseView = () => {
        setOpenView(false);
        setViewImage(null);
    };

    const handleDownload = async () => {
        if (viewImage) {
            try {
                let response;
                if (id) {
                    const proxyUrl = `/api/proxy-image?url=${encodeURIComponent(viewImage)}`;
                    response = await fetch(proxyUrl);
                } else {
                    response = await fetch(viewImage);
                }

                if (response.ok) {
                    const blob = await response.blob();
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = 'downloaded-image.png';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                } else {
                    console.error('Failed to download image');
                }
            } catch (error) {
                console.error('Error in download process:', error);
            }
        } else {
            console.log("No image available");
        }
    };

    const navigate = useNavigate()

    React.useEffect(() => {
        dispatch(getAccount())
        dispatch(getAllMarketingData())
    }, [dispatch]);

    const account = useSelector(state => state.account.Account).find(a => a.matketId == mid && a.Dealer == Dealerid);

    React.useEffect(() => {
        if (account) {
            setid(account?._id)
        }
    }, [account])

    const matchedDealerssss = marketdealer?.dealerData?.[0]?.PaymentDetails

    const [uploadFields, setUploadFields] = React.useState([]);

    React.useEffect(() => {
        dispatch(getDealers()).then((response) => {
            if (response.payload) {
                const dealerData = response.payload;
                const paymentSlips = dealerData.map(dealer => dealer.UploadPaymentSlip).filter(Boolean);
                setUploadFields(paymentSlips.map((url, index) => ({ id: index, url })));
            }
        }).catch(error => {
            console.error("Error fetching dealers:", error);
        });
    }, [dispatch]);

    const addUploadField = () => {
        setUploadFields([...uploadFields, { id: Date.now() }]);
    };

    const [inputFields, setInputFields] = React.useState([]);
    const addInputField = () => {
        setInputFields([...inputFields, { id: Date.now() }]);
    };



    return (
        <Box m="2px" sx={{ overflow: isMobile ? 'auto' : 'hidden', }}>
            {id ? (
                <Header
                    title="UPDATE ACCOUNT"
                    subtitle="Update Your Account Here"
                />
            ) : (
                <Header
                    title="ADD ACCOUNT"
                    subtitle="Manage Your Account Here"
                />
            )}

            <form onSubmit={handleSubmit}>
                <Stack sx={{ width: '100%', marginTop: '30px' }} spacing={4}>

                    <Box
                        display="grid"
                        gap="30px"
                        gridTemplateColumns="repeat(1, minmax(0, 1fr))"
                        sx={{
                            "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
                        }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                                {matchedDealerssss ? (
                                    <>
                                        <TableContainer>
                                            <Table>
                                                <TableHead sx={{ backgroundColor: theme.palette.mode === 'dark' ? '#3e4396' : '#a4a9fc' }}>
                                                    <TableRow>
                                                        <TableCell sx={{ fontSize: '14px' }}>Date</TableCell>
                                                        <TableCell sx={{ fontSize: '14px' }}>Payment Mode</TableCell>
                                                        <TableCell sx={{ fontSize: '14px' }}>Amount</TableCell>
                                                        <TableCell sx={{ fontSize: '14px' }}>Ref NO</TableCell>
                                                        <TableCell sx={{ fontSize: '14px' }}>Attached File</TableCell>
                                                        <TableCell sx={{ fontSize: '14px' }}>Remarks</TableCell>
                                                        <TableCell></TableCell>
                                                        <TableCell sx={{ fontSize: '14px' }}>Date</TableCell>
                                                        <TableCell sx={{ fontSize: '14px' }}>Amount</TableCell>
                                                        <TableCell sx={{ fontSize: '14px' }}>Remarks</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody sx={{ backgroundColor: theme.palette.mode === 'dark' ? '#1f2a40' : '#f0f0f0' }}>
                                                    {matchedDealerssss.map((detail, detailIndex) => (
                                                        <TableRow key={detailIndex}>
                                                            <TableCell sx={{ fontSize: '14px' }}>{detail.PaymentDate}</TableCell>
                                                            <TableCell sx={{ fontSize: '14px' }}>{detail.PaymentMode}</TableCell>
                                                            <TableCell sx={{ fontSize: '14px' }}>{detail.PaymentAmount}</TableCell>
                                                            <TableCell sx={{ fontSize: '14px' }}>{detail.PaymentRefNO}</TableCell>
                                                            <TableCell sx={{ pb: 0 }} >
                                                                {detail.UploadPaymentSlip && (
                                                                    <div>
                                                                        <img
                                                                            src={`${imgUrl}/${detail.UploadPaymentSlip}`}
                                                                            alt="Payment Slip"
                                                                            style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                                                                            onClick={() => handleView(`${imgUrl}/${detail.UploadPaymentSlip}`)}
                                                                        />
                                                                        <IconButton sx={{ mb: 2 }} aria-label="view" onClick={() => handleView(`${imgUrl}/${detail.UploadPaymentSlip}`)}>
                                                                            <RemoveRedEyeIcon />
                                                                        </IconButton>
                                                                    </div>
                                                                )}
                                                            </TableCell>
                                                            <TableCell sx={{ fontSize: '14px' }}>{detail.PaymentRemarks}</TableCell>
                                                            <TableCell></TableCell>
                                                            <TableCell>
                                                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                                                    <TextField
                                                                        fullWidth
                                                                        variant="filled"
                                                                        type="date"
                                                                        label="Date :"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values.AccountDetails?.[detailIndex]?.AccountDate}
                                                                        name={`AccountDetails[${detailIndex}].AccountDate`}
                                                                        error={!!touched.AccountDetails?.[detailIndex]?.AccountDate && !!errors.AccountDetails?.[detailIndex]?.AccountDate}
                                                                        helperText={touched.AccountDetails?.[detailIndex]?.AccountDate && errors.AccountDetails?.[detailIndex]?.AccountDate}
                                                                        sx={{ gridColumn: "span 2" }}
                                                                        InputLabelProps={{
                                                                            shrink: true,
                                                                            style: {
                                                                                color: theme.palette.text.primary
                                                                            }
                                                                        }}
                                                                    />
                                                                </FormControl>
                                                            </TableCell>
                                                            <TableCell>
                                                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                                                    <TextField
                                                                        fullWidth
                                                                        variant="filled"
                                                                        type="text"
                                                                        label="Account Amount :"
                                                                        onBlur={handleBlur}
                                                                        onChange={(e) => {
                                                                            const newValue = e.target.value;
                                                                            const maxAmount = matchedDealerssss[detailIndex]?.PaymentAmount || 0;
                                                                            if (Number(newValue) > maxAmount) {
                                                                                alert(`Account Amount cannot exceed the maximum allowed amount of ${maxAmount}`);
                                                                                setFieldValue(`AccountDetails[${detailIndex}].AccountAmount`, values.AccountDetails?.[detailIndex]?.AccountAmount);
                                                                            } else {
                                                                                handleChange(e);
                                                                            }
                                                                        }}
                                                                        value={values.AccountDetails?.[detailIndex]?.AccountAmount}
                                                                        name={`AccountDetails[${detailIndex}].AccountAmount`}
                                                                        error={!!touched.AccountDetails?.[detailIndex]?.AccountAmount && !!errors.AccountDetails?.[detailIndex]?.AccountAmount}
                                                                        helperText={touched.AccountDetails?.[detailIndex]?.AccountAmount && errors.AccountDetails?.[detailIndex]?.AccountAmount}
                                                                        sx={{ gridColumn: "span 2" }}
                                                                        InputLabelProps={{
                                                                            shrink: !!values.AccountDetails?.[detailIndex]?.AccountAmount,
                                                                            style: {
                                                                                color: theme.palette.text.primary
                                                                            }
                                                                        }}
                                                                    />
                                                                </FormControl>
                                                            </TableCell>
                                                            <TableCell>
                                                                <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                                                                    <TextField
                                                                        fullWidth
                                                                        variant="filled"
                                                                        type="text"
                                                                        label="Account Remarks :"
                                                                        onBlur={handleBlur}
                                                                        onChange={handleChange}
                                                                        value={values.AccountDetails?.[detailIndex]?.AccountRemarks}
                                                                        name={`AccountDetails[${detailIndex}].AccountRemarks`}
                                                                        error={!!touched.AccountDetails?.[detailIndex]?.AccountRemarks && !!errors.AccountDetails?.[detailIndex]?.AccountRemarks}
                                                                        helperText={touched.AccountDetails?.[detailIndex]?.AccountRemarks && errors.AccountDetails?.[detailIndex]?.AccountRemarks}
                                                                        sx={{ gridColumn: "span 2" }}
                                                                        InputLabelProps={{
                                                                            shrink: !!values.AccountDetails?.[detailIndex]?.AccountRemarks,
                                                                            style: {
                                                                                color: theme.palette.text.primary
                                                                            }
                                                                        }}
                                                                    />
                                                                </FormControl>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </>
                                ) : (
                                    <p style={{ marginLeft: '20px' }}>Data not found</p>
                                )}
                            </div>
                        </div>
                    </Box>
                    <FormControl>
                        <Stack direction="row" spacing={2} sx={{ m: 1, minWidth: 120 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                type="button"
                                onClick={handleSubmit}
                            >
                                {id ? 'Update' : 'Submit'}
                            </Button>
                        </Stack>
                    </FormControl>


                    <Dialog
                        fullScreen={fullScreen}
                        open={openView}
                        onClose={handleCloseView}
                        aria-labelledby="responsive-dialog-title"
                        maxWidth="sm"
                        fullWidth
                    >
                        <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: theme.palette.background.purple, textAlign: 'right' }}>
                            <Button
                                onClick={handleDownload}
                                style={{ color: theme.palette.text.primary }}
                                startIcon={<DownloadIcon />}
                                disabled={!viewImage}
                            >
                                Download
                            </Button>
                        </DialogTitle>
                        <DialogContent style={{ backgroundColor: theme.palette.background.purple, display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                            {viewImage ? (
                                <div style={{ maxWidth: '100%', maxHeight: '80vh' }} >
                                    <img
                                        src={viewImage}
                                        alt="Uploaded Image"
                                        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                        ref={downloadRef}
                                    />
                                </div>
                            ) : (
                                <p>No image to display</p>
                            )}
                        </DialogContent>
                        <DialogActions style={{ backgroundColor: theme.palette.background.purple }}>
                            <Button autoFocus onClick={handleCloseView} style={{ color: theme.palette.text.primary }}>
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Stack>
            </form>
        </Box>
    );
}

